export interface ProductChoice {
    selectedProduct: string;
    productName: string;
    pensionPotQues: string;
    flexwithQues: string;
    withdrawingMoneyQues: string;
    financialDependantsQues: string;
    riskAndStaticQuestion: any[];
    source: string;
    productOptions: string;
}
